/*
 *   File : category.js
 *   Author : https://evoqins.com
 *   Description : Category card component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';

//Style
import style from "../../Styles/Component/card.module.scss";

// Assets
import CardBottomPattern from "../../Assets/Images/Card/card-pattern.png";

//Custom component
import { Icon } from '../Icon';

const CategoryCard = (props) => {

    const [icon, setIcon] = useState("");
    const [footerBackground, setFooterBackground] = useState("");
    const [background, setBackground] = useState("");

    useEffect(() => {
        switch (props.category.category) {
            case "alphaBasket":
                setIcon(require("../../Assets/Images/Card/basket-icon.svg").default);
                setFooterBackground("linear-gradient(90deg, #00DFFE -1.98%, #60EFFF 102.29%)");
                setBackground("#F6FEFF");
                break;
            default:
                setIcon('');
                break;
        }
    }, [props.category]);

    return (
        <div className={`${style.e_category_card_wrapper} border-radius-8 cursor-pointer h-100 d-flex flex-column`}
            onClick={() => props.handleClick(props.category.id)}>
            <div className={`${style.e_category_card} flex-fill`}>
                <div className={`${style.e_header_wrapper} position-relative h-100`}
                    style={{ background: background }}>
                    <div className='padding-14px-top padding-30px-bottom px-3'>
                        <h6 className='e-font-16-res mb-2 e-alt-font-lato e-text-chinese-black e-font-18 e-font-weight-600 line-height-20px'>
                            {props.category.category}
                        </h6>
                        <p className='mb-0 e-alt-font-lato e-text-outer-space e-font-12 e-font-weight-400 line-height-16px'>
                            {props.category.description}
                        </p>
                    </div>

                    <img src={icon}
                        draggable={false}
                        className={`${style.e_basket_icon} p-2 e-bg-ghost-white border-radius-8 position-absolute top--12px right-16px overflow-visible`}
                        alt='basket-icon' />

                </div>
            </div>
            <div className={`${style.e_footer_wrapper} h-34 px-3 position-relative d-flex align-items-center`}
                style={{
                    backgroundImage: `url(${CardBottomPattern}), ${footerBackground}`,
                    backgroundSize: "cover",
                    backgroundPosition: "top",
                    backgroundRepeat: "no-repeat",
                    backgroundBlendMode: "overlay"
                }}>
                <div className='d-inline-flex gap-1 align-items-center'>
                    <span className='e-text-navy-blue e-alt-font-lato e-font-12 e-font-weight-600 line-height-16px'>
                        View products
                    </span>
                    <Icon icon="right-arrow"
                        color="#060663"
                        className="d-flex transition padding-2px-top"
                        size="14px" />
                </div>

                {/* <img src={require('../../Assets/Images/Card/card-pattern.png')}
                    className='position-absolute w-100 top-0 start-0 h-100 z-0' /> */}
            </div>
        </div>
    )
}

CategoryCard.defaultProps = {
    handleClick: () => { }
}

export default CategoryCard;
